export const getChatMessages = state => state.chat.visibleMessages;
